import { render, staticRenderFns } from "./KeyStatus.vue?vue&type=template&id=0b25974c&"
import script from "./KeyStatus.vue?vue&type=script&lang=ts&"
export * from "./KeyStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports